// Real 5-star Google reviews (shared across hero strip and reviews section)
export const allReviewsUrl =
  'https://www.google.com/maps/place/VK+Tax+Guide/@43.6415857,-79.3802643,17z/data=!3m1!5s0x882b38045f838361:0xf7990777bd48b6b2!4m8!3m7!1s0x89d4cb033f389d83:0x49bda5ae26f3185a!8m2!3d43.6415818!4d-79.3776894!9m1!1b1!16s%2Fg%2F11mzqy4xh_';

export const writeReviewUrl =
  'https://search.google.com/local/writereview?placeid=ChIJg504PwPL1IkRWhjzJq6lvUk';

export const reviews = [
  {
    name: 'Jayesh Shanmughan',
    rating: 5,
    content:
      "I had an excellent experience with VK Tax Guide! They handled tax filing for both my partner and me with exceptional sincerity and care. The entire process was smooth, and their attention to detail was impressive. It's rare to find tax professionals who genuinely go the extra mile.",
    initials: 'JS',
    color: 'bg-blue-500',
    reviewUrl: 'https://maps.app.goo.gl/bZVwpsaBaqUZthrB6',
  },
  {
    name: 'Aakash Darji',
    rating: 5,
    content:
      'Had a great experience filing my taxes with them. The process was smooth, professional, and everything was explained clearly. They were very helpful and made the whole filing process easy. Highly recommend their service.',
    initials: 'AD',
    color: 'bg-purple-500',
    reviewUrl: 'https://maps.app.goo.gl/CtavbTVWWiM3u6Um9',
  },
  {
    name: 'Eli Zandi',
    rating: 5,
    content:
      "I had a great experience with VK Tax Guide this year. Their team was professional, responsive, and made the entire tax process smooth and stress-free. I'm very satisfied with their service and would definitely recommend them.",
    initials: 'EZ',
    color: 'bg-pink-500',
    reviewUrl: 'https://maps.app.goo.gl/mzBFgjP6e8TUKCfC8',
  },
  {
    name: 'Sai Kiran',
    rating: 5,
    content:
      'Varshil is really good at doing taxes, he has helped me with my and my family taxes every year. He has deep knowledge into accounting and has been guiding us during filing process. Highly recommend him.',
    initials: 'SK',
    color: 'bg-green-500',
    reviewUrl: 'https://maps.app.goo.gl/VdtXRQnbACRTCUJ47',
  },
  {
    name: 'Maulik Patel',
    rating: 5,
    content:
      'It was very great experience. He is very responsible person, even when i call for any query he always respond with satisfactory answer. Highly recommend.',
    initials: 'MP',
    color: 'bg-orange-500',
    reviewUrl: 'https://maps.app.goo.gl/VfVW4v5eFPNaJdwz9',
  },
  {
    name: 'Mayank Wankhede',
    rating: 5,
    content:
      "I had a great experience with VK Tax Guide for my tax filing since the past 5 years. The process was smooth and straightforward, and I received my refund/assessment without any issues. What really stood out was the follow-up, Varshil checked in after filing to make sure everything went well. It's rare to find that level of care and support even after the job is done. Highly recommend VK Tax Guide for anyone looking for reliable and trustworthy tax assistance!",
    initials: 'MW',
    color: 'bg-teal-600',
    reviewUrl: 'https://maps.app.goo.gl/YEux2ht4pYydqf576',
  },
];
